// extracted by mini-css-extract-plugin
var _1 = "rFdjf";
var _2 = "FjJ_Y";
var _3 = "lFgwv";
export { _1 as "base", _2 as "label", _3 as "typeValue" }
